import React, { Fragment } from 'react'
import SliderTestimoni from '../Slider/SliderTestimoni'

const SecTestimonial = (props) => {
    return (
        <section className="position-relative">
            {
                props.ornamen == false ? "" : <Fragment><img src="./../images/sd (2).png" className="images__wrap-1" alt="" />
                    <img src="./../images/Clip path group (1).png" className="images__wrap-2" alt="" /></Fragment>
            }

            <div className="container position-relative z-2">
                <h2 className="normal font__size--50 text__50-1024 text__50-sm text__50-xs text-center">What our customers are saying</h2>

                <div className="mt__3">
                    <SliderTestimoni />
                </div>
            </div>
        </section>

    )
}

export default SecTestimonial